/**
 * 
 * @param param If not set, We default to English
 * @returns All key:values pairs from json file
 */

export const fetchTranslations = ({ language = "en" }) =>
  import(`../lang/${language}.json`).then((module) => {
    return module.default;
  });
